// extracted by css-extract-rspack-plugin
export default {"ChipLabel":"BfuiA","ChipRoot":"I_IGr","ChipIconWrapper":"c1mXw","ChipCheckIcon":"gHyKk"};